export {
    cloneSnapshot,
    countQuestions,
    createOption,
    createQuestion,
    createSection,
    createUniqueFieldName,
    defaultOptions,
    defaultSnapshot,
    findQuestionPosition,
    getActiveSectionId,
    getAllQuestions,
    isOptionFieldType,
    normalizeOption,
    normalizeRatingConfig,
    normalizeSnapshotForBuilder,
    normalizeSnapshotForSave,
    optionLabel,
    resolveFieldType,
    supportsPlaceholder,
    validatePublishableSnapshot,
    validationForType,
} from '@/lib/custom-surveys/schema';

export const getCustomSurveySectionElementId = (sectionId: string) =>
    `custom-survey-section-${sectionId}`;

export const getCustomSurveyQuestionElementId = (questionId: string) =>
    `custom-survey-question-${questionId}`;

export { extractApiErrorMessage } from '@/lib/api-errors';
